module.exports = __webpack_public_path__ + "missing-vehicle-photo-2a6aab273e.jpg";